import { sproutDarkTheme } from "../../../generated/compatibility";
export var navigation = sproutDarkTheme.colors.navigation;
export var datePicker = sproutDarkTheme.colors.datePicker;
export var ai = sproutDarkTheme.colors.ai;
export var analytics = sproutDarkTheme.colors.analytics;
export var listening = sproutDarkTheme.colors.listening;
export var growth = sproutDarkTheme.colors.growth;
export var cardControl = sproutDarkTheme.colors.cardControl;
export var tags = sproutDarkTheme.colors.tags;
export default sproutDarkTheme;